<footer class="footer">
  <div class="layout">
    <div class="top">
      <figure class="logo">
        <img
          src="https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/Logo_Union_Branco.svg"
          alt="Logo Union Solutions"
          loading="lazy"
          style="width: 300px"
        />
      </figure>
      <div class="extra">
        <p class="title-footer">Siga-nos nas redes sociais</p>
        <ul class="social-links">
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/union_solutions/"
              aria-label="Instagram da Union Solutions"
            >
              <i class="fab fa-instagram" aria-hidden="true"></i
            ></a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/UnionSolutionsHolding"
              aria-label="Facebook da Union Solutions"
            >
              <i class="fab fa-facebook-square" aria-hidden="true"></i
            ></a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/company/union-solutions/"
              aria-label="LinkedIn da Union Solutions"
            >
              <i class="fab fa-linkedin" aria-hidden="true"></i
            ></a>
          </li>
        </ul>
      </div>
    </div>

    <div class="bottom">
      <nav aria-label="Menu do footer" class="menu-nav">
        <ul class="menu">
          <li><a class="menu-item" href="/" aria-current="page">Início</a></li>
          <li>
            <a class="menu-item" href="/areas-de-atuacao/">Áreas de Atuação</a>
          </li>
          <li><a class="menu-item" href="/institucional/">Institucional</a></li>
          <li><a class="menu-item" href="/unidades/">Nossa Rede</a></li>
          <li><a class="menu-item" href="/blog/">Blog</a></li>
          <li><a class="menu-item" href="/contato/">Contato</a></li>
          <li><a class="menu-item" href="/solucoes/">Soluções</a></li>
        </ul>
      </nav>
      <nav aria-label="navegação de contato" class="contact-nav">
        <a
          class="btn transparent"
          target="_blank"
          rel="noopener noreferrer"
          href="https://api.whatsapp.com/send?phone=5511963056359"
          aria-label="Contato via WhatsApp"
          >(11) 96305-6359</a
        >
      </nav>
    </div>
  </div>
</footer>
<div class="copy">
  <div class="layout">
    <p>
      O uso deste site está sujeito aos termos e condições das
      <a href="/politicas-de-cookies">Políticas de Cookies</a> e da
      <a href="/politicas-de-privacidade">Política de Privacidade</a
      >.<br />Copyright © 2021 | Union Solutions
    </p>
  </div>
</div>
